import React, { useState, useEffect } from "react";
import Header from "../common/Header";
import Aside from "../common/Asside";

function Performance() {
    const [activeTab, setActiveTab] = useState("Player");
    const [playerData, setPlayerData] = useState([]);
    const [totals, setTotals] = useState({
        total_deposit: 0,
        total_withdrawal: 0,
        total_turnover: 0,
        total_bonus: 0,
        total_vip_bonus: 0,
        total_ref_commission: 0,
    });
    const formatDate = (date) => {
        return new Date(date).toLocaleString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      };
      

    useEffect(() => {
        if (activeTab === "Player") {
            fetchPlayerData();
        }
    }, [activeTab]);

    const fetchPlayerData = async () => {
        try {
            const response = await fetch("https://api2b.pro/api/performance/player", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });
            if (response.ok) {
                const data = await response.json();
                setPlayerData(data.userData);
                setTotals(data.totals);
            } else {
                console.error("Failed to fetch player data");
            }
        } catch (error) {
            console.error("Error fetching player data:", error);
        }
    };

    return (
        <div>
            <Header />
            <div className="container-flex">
                <Aside />
                <div className="main">
                    <div className="page-content">
                        <div className="main-inner">
                            <div className="page-content-body" style={{ display: 'block' }}>
                                <div className="section">
                                    <div className="section-head">
                                        <h2 className="title">Performance</h2>
                                    </div>
                                    <div className="section-body">
                                        <div id="performanceTab">
                                            <ul className="section_tab">
                                                <li className="section_tab-item">
                                                    <a
                                                        className={`section_tab-link ${activeTab === "Player" ? "active" : ""}`}
                                                        onClick={() => setActiveTab("Player")}
                                                        style={{ display: 'flex' }}
                                                        href="#player"
                                                    >
                                                        Player
                                                    </a>
                                                </li>
                                                <li className="section_tab-item">
                                                    <a
                                                        className={`section_tab-link ${activeTab === "Downline" ? "active" : ""}`}
                                                        onClick={() => setActiveTab("Downline")}
                                                        style={{ display: 'flex' }}
                                                        href="#downline"
                                                    >
                                                        Downline
                                                    </a>
                                                </li>
                                            </ul>

                                            {activeTab === "Player" && (
                                                <div className="section-body fade active" id="playerPerformance">
                                                    <form action="#" id="performanceForm" noValidate="novalidate">
                                                        <div className="d-flex">
                                                            <div className="form-group form-column form-4-col">
                                                                <label className="label bold">Player </label>
                                                                <input className="form-control" name="playerFormUserId" id="playerFormUserId" />
                                                            </div>
                                                            <div className="form-group form-column form-4-col">
                                                                <label className="label bold">From</label>
                                                                <input type="date" className="form-control" name="startTime" />
                                                            </div>
                                                            <div className="form-group form-column form-4-col">
                                                                <label className="label bold">To</label>
                                                                <input type="date" className="form-control" name="endTime" />
                                                            </div>
                                                            <div className="form-group form-column form-4-col">
                                                                <label className="label bold">Currency</label>
                                                                <select className="form-control" name="currency">
                                                                    <option value={8}>BDT</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="table-wrap">
                                                            <table id="performanceTable" className="table dataTable">
                                                                <thead>
                                                                    <tr>
                                                                        <th>#</th>
                                                                        <th>Username</th>
                                                                        <th>Currency</th>
                                                                        <th>Registration Time</th>
                                                                        <th>Phone Number</th>
                                                                        <th>Email Address</th>
                                                                        <th>Total Deposit</th>
                                                                        <th>Total Withdrawal</th>
                                                                        <th>Total Number of Bets</th>
                                                                        <th>Total Turnover</th>
                                                                        <th>Profit Loss</th>
                                                                        <th>Bonus</th>
                                                                        <th>VIP Cash Bonus</th>
                                                                        <th>Referral Commission</th>
                                                                        <th>Revenue Adjustment</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {playerData.map((player, index) => (
                                                                        <tr key={index}>
                                                                            <td>{index + 1}</td>
                                                                           <td>
                                                                           {(() => {
                                                                                const username = player.username || '';
                                                                                const visibleChars = 3;
                                                                                const masked = '*'.repeat(Math.max(0, username.length - visibleChars));
                                                                                const visible = username.slice(-visibleChars);
                                                                                return masked + visible;
                                                                                })()}
                                                                           </td>
                                                                            <td>{player.currency}</td>
                                                                            
                                                                            <td>{formatDate(new Date(player.created_at))}</td>
                                                                            <td>
                                                                            -
                                                                           </td>
                                                                           <td>
                                                                            -
                                                                           </td>
                                                                            <td>{player.total_deposit || "0.00"}</td>
                                                                            <td>{player.total_withdrawal || "0.00"}</td>
                                                                            <td>{player.total_number_of_bets || "0"}</td>
                                                                            <td>{player.total_turnover || "0.00"}</td>
                                                                            <td
                                                                            style={{
                                                                                color: player.total_loss > player.total_profit ? "red" : "black",
                                                                            }}
                                                                            >
                                                                            {player.total_loss > player.total_profit ? player.total_loss : player.total_profit || "0.00"}
                                                                            </td>

                                                                            <td>{player.total_bonus || "0.00"}</td>
                                                                            <td>{player.total_vip_bonus || "0.00"}</td>
                                                                            <td>{player.total_ref_commission || "0.00"}</td>
                                                                            <td>{player.revenue_adjustment || "0.00"}</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                                <tfoot>
                                                                    <tr>
                                                                        <th colSpan={7}>Totals</th>
                                                                        <th>{totals.total_deposit}</th>
                                                                        <th>{totals.total_withdrawal}</th>
                                                                        <th>{totals.total_number_of_bets}</th>
                                                                        <th>{totals.total_turnover}</th>
                                                                        <th
                                                                        style={{
                                                                            color: totals.total_loss > totals.total_profit ? "red" : "white",
                                                                        }}
                                                                        >
                                                                        {totals.total_loss > totals.total_profit ? totals.total_loss : totals.total_profit}
                                                                        </th>

                                                                        <th>{totals.total_bonus}</th>
                                                                        <th>{totals.total_vip_bonus}</th>
                                                                        <th>{totals.total_ref_commission}</th>
                                                                        <th>0</th>
                                                                    </tr>
                                                                </tfoot>
                                                            </table>
                                                        </div>
                                                    </form>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="section-foot">
                                        <div className="btn-group float-right">
                                            <button type="button" className="btn-primary">
                                                <span className="ic-search" /> <span className="text">Search</span>
                                            </button>
                                        </div>
                                        <div className="btn-group float-right">
                                            <button type="button" className="btn-primary">
                                                <span className="ic-excel" /> <span className="text">Export</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <footer className="footer">
                            Copyright © 2020. All rights Reserved
                        </footer>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Performance;
